import { fetchAPIWithOutBaseUrl, fetchAPI, fetchAPIXWWWFrom } from './api';

// const homePage = () => fetchJson('/assets/jsons/markDown/aboutUs.json');

const paramPerpage = '?per_page=50';
// const param = '?per_page=100';
// const paramTh = '?per_page=100&lang=th';

const convertParam = (params) => {
  // let result = null;
  if (params === undefined || params === null) {
    // console.log('param');
  } else {
    return `${paramPerpage}&${params}`;
  }
  return paramPerpage;
};

const instagram = param => fetchAPIWithOutBaseUrl('https://api.instagram.com/v1/users/self/media/recent/?access_token=9267524762.9bb85f8.5bfd4e72c2f94e9293e8043e9fcbd072', { method: 'GET' });
const homePage = param => fetchAPI(`/wp-json/wp/v2/pages${convertParam(param)}`, { method: 'GET' });
const newsEvent = param => fetchAPI(`/wp-json/wp/v2/new${convertParam(param)}`, { method: 'GET' });
const products = param => fetchAPI(`/wp-json/wp/v2/product${convertParam(param)}`, { method: 'GET' });
const allPage = param => fetchAPI(`/wp-json/wp/v2/pages${convertParam(param)}`, { method: 'GET' });
const settings = param => fetchAPI(`/wp-json/acf/v3/options/options${convertParam(param)}`, { method: 'GET' });
const signUp = data => fetchAPI('/user/sign-up', { method: 'POST', body: data });
const sendEnquiry = data => fetchAPIXWWWFrom('/wp-json/contact-form-7/v1/contact-forms/155/feedback', {
  method: 'POST',
  body: data,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
});
export {
  instagram,
  homePage,
  newsEvent,
  products,
  allPage,
  settings,
  signUp,
  sendEnquiry,
};



// WEBPACK FOOTER //
// ./src/services/index.js